import useAuth from '@/hooks/useAuth';
import { useSearchParams } from '@/hooks/useSearchParams';
import { useCreateOrUpdateWorkflowMutation } from '@/queries/workflow.queries';
import uuidService from '@/services/uuid.service';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';

export function useSectionWorkflowsController() {
	const { t } = useTranslation();
	const createWorkflowMutation = useCreateOrUpdateWorkflowMutation();
	const auth = useAuth();
	const history = useHistory();
	const params = useSearchParams();
	const editWorkflowId = params.get('wfid');

	function handleCreateWorkflowClick() {
		const id = uuidService.v4();

		return createWorkflowMutation
			.mutateAsync({
				workflow: {
					id,
					name: id,
					actions: [],
					owner: {
						type: 'WorkflowOwnerUser',
						id: auth.getCurrentUser().userId,
					},
					type: 'PutAfterConfirmingBookingWorkflowRequest',
					trigger: {
						after: null,
					},
				},
			})
			.then(() => {
				openWorkflowModal(id);
			})
			.catch(() => {
				openWorkflowModal(id);
			});
	}

	function handleEditWorkflowClick(id: string) {
		openWorkflowModal(id);
	}

	function closeEditWorkflowModal() {
		params.delete('wfid');
		history.push({ search: params.toString() });
	}

	function openWorkflowModal(id: string) {
		params.set('wfid', id);
		history.push({ search: params.toString() });
	}

	return {
		handleEditWorkflowClick,
		closeEditWorkflowModal,
		handleCreateWorkflowClick,
		t,
		isEditWorkflowModalOpen: !!editWorkflowId,
	};
}
